// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"ea3cebf3","485":"4df5142e","864":"4a775529"}[chunkId] + ".chunk.js";
};